export default __webpack_public_path__ + "redux.8b603223.png";